import { Grid } from '@material-ui/core';
import React from 'react';
import { ImageDto } from '../../groupVisits.dtos';
import ImageCard from './imageCard';

interface IProps {
  onClick: (image: string, type: string) => void;
  images: ImageDto[];
  onSelect: (image: ImageDto) => void;
}

const ImageList: React.FC<IProps> = ({ onClick, images, onSelect }) => {
  return (
    <Grid container direction='row' wrap='wrap'>
      {images.map((image, i) => (
        <ImageCard
          key={image.id}
          onClick={onClick}
          image={image}
          onSelect={onSelect}
        />
      ))}
    </Grid>
  );
};

export default ImageList;
